// angular dependencies
import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

// third-party dependencies
import { AuthTokens } from 'aws-amplify/auth';
import { switchMap } from 'rxjs/operators';

// fantaz dependencies
import { environment } from '@fantaz/shared/app-config';
import { AuthServiceInjectionToken } from '../services/auth';

const getAuthenticationToken = (
  tokens: AuthTokens | undefined,
): string | undefined => {
  if (environment.cognitoAdvancedSecurity === true) {
    return tokens?.accessToken?.toString();
  } else {
    return tokens?.idToken?.toString();
  }
};

export const httpAuthInterceptor = () => {
  const intercept: HttpInterceptorFn = (req, next) => {
    const authService = inject(AuthServiceInjectionToken);

    return authService.getAuthenticationToken().pipe(
      switchMap((token) => {
        if (token && req.url.includes(environment.apiBaseUrl)) {
          return next(
            req.clone({
              headers: token
                ? req.headers.set('Authorization', `Bearer ${token}`)
                : req.headers,
            }),
          );
        }

        return next(req);
      }),
    );
  };

  return intercept;
};
